import { render, staticRenderFns } from "./productcode_management.vue?vue&type=template&id=49e13e9f&scoped=true"
import script from "./productcode_management.vue?vue&type=script&lang=js"
export * from "./productcode_management.vue?vue&type=script&lang=js"
import style0 from "./productcode_management.vue?vue&type=style&index=0&id=49e13e9f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e13e9f",
  null
  
)

export default component.exports